module.exports = __webpack_public_path__ + "img/weigaoLogo.357c0407.png";